import { Component, inject } from '@angular/core';

import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-delete-btn-admin',
  templateUrl: './delete-btn-admin.component.html',
  styleUrls: ['./delete-btn-admin.component.scss'],
  standalone: false
})
export class DeleteBtnAdminComponent {
  auth = inject(AuthService);

}
